module.exports = __webpack_public_path__ + "static/media/budget-revision.45ff9dc9.svg";